import { SettingsServiceTypes as Types } from 'common/settingsService/types';
import { SettingsGroup } from 'common/settingsService/impl/models/SettingsGroup';

export class SettingsServiceState {
  private readonly stateModel: Types.StateModel;

  constructor(state: Types.StateModel) {
    this.stateModel = state;
  }

  static fromArrayOfGroups(arrayOfGroups: SettingsGroup[]) {
    return new SettingsServiceState(
      arrayOfGroups.reduce((acc, group) => ({ ...acc, [group.name]: group.model }), {} as Types.StateModel)
    );
  }

  static fromStateModel(stateModel: Types.StateModel) {
    return new SettingsServiceState(stateModel);
  }

  merge(state: SettingsServiceState) {
    return SettingsServiceState.fromStateModel({ ...this.model, ...state.model });
  }

  mergeGroup(group: SettingsGroup) {
    const prevGroupModel = this.model[group.name as keyof typeof this.model];
    if (!prevGroupModel) {
      this.model[group.name as keyof typeof this.model] = group.model as Types.StateModel[keyof typeof this.model];
    } else {
      this.model[group.name as keyof typeof this.model] =
        SettingsGroup.fromGroupModel(prevGroupModel).merge(group).model;
    }
    return this;
  }

  get model() {
    return this.stateModel;
  }
}
